import { Input } from '@components/core-ui/form-elements/Input';
import { Select } from '@components/core-ui/form-elements/Select';
import { Textarea } from '@components/core-ui/form-elements/Textarea';
import { STATES } from 'app/types/states';

import { Wrapper } from './ContactSalesForm/styles/Wrapper';

const stateOptions = STATES.map((state) => {
  return { value: state.value, label: state.name };
});

type TForm = {
  firm: string;
  name: string;
  email: string;
  phone: string;
  location: string;
  numOfReporters: string;
  numOfTranscriptionists: string;
  additional: string;
};

type TProps = {
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  updateForm: (name: string, value: string) => void;
  formState: TForm;
};

export const ContactSalesForm = ({ handleChange, formState, updateForm }: TProps) => (
  <Wrapper>
    <h3>Get in touch</h3>
    <Input
      className="form-input w-full"
      label="Firm/Agency"
      name="firm"
      onChange={handleChange}
      value={formState.firm}
      required
    />
    <Input
      className="form-input w-full"
      label="Full Name"
      name="name"
      onChange={handleChange}
      value={formState.name}
      required
    />
    <Input
      className="form-input w-full"
      label="Email"
      type="email"
      name="email"
      onChange={handleChange}
      value={formState.email}
      required
    />
    <Input
      className="form-input w-full"
      label="Phone"
      name="phone"
      onChange={handleChange}
      value={formState.phone}
      required
    />
    <Select
      className="form-select w-full"
      options={stateOptions}
      label="State you are located"
      name="location"
      value={formState.location}
      onChange={(name, value) => updateForm(name, value)}
    />
    <Input
      className="form-input w-full"
      label="Number of Reporters you have"
      name="numOfReporters"
      onChange={handleChange}
      value={formState.numOfReporters}
    />
    <Input
      className="form-input w-full"
      label="Number of Transcriptionists you have"
      name="numOfTranscriptionists"
      onChange={handleChange}
      value={formState.numOfTranscriptionists}
    />
    <Textarea
      className="textarea-wrapper w-full"
      label="Additional information"
      name="additional"
      onChange={handleChange}
      value={formState.additional}
    />
  </Wrapper>
);
